type SettingsSelectOption = {
  value: string;
  label: string;
  /** Set when the label is written in a different language from the page. */
  lang?: string;
};

type SettingsSelectProps = {
  value: string;
  options: SettingsSelectOption[];
  disabled?: boolean;
  ariaLabel: string;
  onChange: (value: string) => void;
};

export function SettingsSelect({
  value,
  options,
  disabled = false,
  ariaLabel,
  onChange,
}: SettingsSelectProps) {
  return (
    <select
      value={value}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(event) => onChange(event.target.value)}
      className="w-full min-w-0 rounded-[10px] border px-3 py-2.5 text-sm disabled:opacity-50 sm:w-auto sm:min-w-[220px]"
      style={{
        color: 'var(--gs-ink)',
        background: 'var(--gs-field)',
        borderColor: 'var(--gs-line)',
        fontFamily: 'inherit',
      }}
    >
      {options.map((option) => (
        <option key={option.value || '__empty'} value={option.value} lang={option.lang}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
